import filestack from "filestack-js";

export default class Filepicker {
  /* @ngInject */
  constructor($q, $rootScope, Image) {
    this.filestackClient = filestack.init(process.env.FILESTACK_API_KEY);
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.Image = Image;
  }

  uploadSectionImage() {
    const s3Path = `/filestack/img/`;
    return this._uploadImage({}, { path: s3Path }, true);
  }

  uploadSectionUrlImage(imageUrl) {
    return this.filestackClient
      .storeURL(imageUrl)
      .then((originalImgMetadata) => {
        return this.Image.create(originalImgMetadata);
      })
      .then((originalImg) => {
        const transformedUrl = this.filestackClient.transform(
          originalImg.metadata.url,
          {
            resize: { width: 1080 },
            output: { compress: true },
          }
        );
        return this.filestackClient
          .storeURL(transformedUrl)
          .then((transformedImgMetadata) => {
            return this.Image.create(transformedImgMetadata);
          });
      })
      .then((image) => {
        return image.metadata;
      })
      .catch((error) => {
        return false;
      });
  }

  uploadSectionBase64Image(imageBase64) {
    return this.filestackClient
      .upload(
        imageBase64,
        {},
        {
          filename: process.env.AWS_FILENAME,
          location: process.env.AWS_LOCATION,
          path: process.env.AWS_PATH,
          container: process.env.AWS_CONTAINER_NAME,
          region: process.env.AWS_REGION,
          access: process.env.AWS_ACCESS,
        }
      )
      .then((imgMetadata) => {
        return this.Image.create(imgMetadata);
      })
      .then((image) => {
        return image.metadata;
      })
      .catch((error) => {
        return false;
      });
  }

  uploadProfileImageV2() {
    const s3Path = `/filestack/img/user/`;
    return this._uploadImage({ cropForce: true }, { path: s3Path }, false);
  }

  uploadOrganizationImage() {
    const s3Path = `/filestack/img/organization/`;
    return this._uploadImage(
      { aspectRatio: 4 / 3, cropForce: true },
      { path: s3Path },
      false
    );
  }

  uploadOrganizationSignature() {
    const s3Path = `/filestack/img/organization/signature/`;
    return this._uploadImage(
      { aspectRatio: 4 / 3, cropForce: true },
      { path: s3Path },
      true
    );
  }

  _uploadImage(options = {}, store = {}, imageCollection) {
    const storeOptions = {
      location: store.location || process.env.AWS_LOCATION,
      path: store.path || undefined,
      container: process.env.AWS_CONTAINER_NAME,
      region: process.env.AWS_REGION,
      access: process.env.AWS_ACCESS,
    };

    const filestackClientOptions = {
      accept: options.mimetype || ["image/gif", "image/png", "image/jpeg"],
      fromSources: options.fromSources || [
        "local_file_system",
        "url",
        "googledrive",
        "box",
      ],
      lang: this.$rootScope.organization.appLanguage,
      uploadInBackground: false,
      maxSize: parseInt(process.env.FILESTACK_MAX_SIZE),
      transformations: {
        rotate: options.rotate || true,
        circle: options.circle || true,
        crop: {
          aspectRatio: options.aspectRatio || 1,
          force: options.cropForce || false,
        },
      },
    };

    if (process.env.ENV === "prod" || process.env.ENV === "staging")
      filestackClientOptions.storeTo = storeOptions;

    return this.filestackClient
      .pick(filestackClientOptions)
      .then((response) => {
        const imgMetadata = response.filesUploaded[0];
        if (imageCollection) return this.Image.create(imgMetadata);
        else return imgMetadata;
      })
      .then((image) => {
        if (image.metadata) return image.metadata;
        else return image;
      });
  }
}
